import { Box, Typography } from "@mui/material";
import { useMyMember } from "../../redux/member/memberHooks";
import { Avatar, Button } from "@mui/joy";
import { useNavigate } from "react-router-dom";
import { AppRouter } from "../../appRouter";
import { RouterConfig } from "../config/routerConfig";

/**
 *
 * @returns {ReactElement} AvatarMenu page
 */
export function AvatarMenu() {
  const { member } = useMyMember();
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate(RouterConfig.profile)}
      color="neutral"
      size="sm"
      sx={{
        background: "rgba(255,255,255,.1)",
        "&:hover": {
          background: "rgba(255,255,255,.2)",
        },
        "&:active": {
          background: "rgba(255,255,255,.2)",
        },
      }}
      startDecorator={
        <Avatar
          size="sm"
          sx={{ border: "solid 1px white", height: 24, width: 24 }}
          src={member?.avatar}
        />
      }
    >
      {member?.firstName ?? ""} {member?.lastName ?? ""}
    </Button>
  );
}
